/**
 * 로그인 후 리다이렉트할 URL을 생성하는 함수
 *
 * @param {string} returnUrl - 리다이렉트할 기본 URL
 * @param {boolean} [useCurrentSearchParam=true] - 현재 페이지의 검색 파라미터를 포함할지 여부
 * @returns {string} 인코딩된 returnUrl을 포함한 검색 파라미터 문자열
 *
 * @example
 * // 현재 URL이 /page?filter=active 인 경우
 * createLoginReturnUrl('/dashboard')
 * // 결과: "?returnUrl=%2Fdashboard%3Ffilter%3Dactive"
 *
 * createLoginReturnUrl('/dashboard', false)
 * // 결과: "?returnUrl=%2Fdashboard"
 */
export const createReturnUrl = (returnUrl: string, useCurrentSearchParam = true) => {
  const originSearchParams = useCurrentSearchParam ? window.location.search : '';
  return `?returnUrl=${encodeURIComponent(`${returnUrl}${originSearchParams}`)}`;
};
